export default __webpack_public_path__ + "static/media/017-snapchat.1e07b1d0.svg";